import { faHome, faPhone, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { IAtendimentoVendas } from "../../../../Interfaces/Vendas/GestaoAtendimentos/AtendimentosVendas";
import {
    setClassBgStatus,
    setClassLabelStatus,
} from "../../../../Tools/Classtools";
import {
    formatedTelefone,
    formatMoneyReais,
} from "../../../../Tools/FormatTools";

import "../styles.css";
export interface IInforAnaliseCredito {
    DS_STATUS_ANALISE_CREDITO: string;
    DT_VALIDADE_ANALISE_CREDITO: string;
    DS_RESPONSAVEL_ANALISE_CREDITO: string;
    VL_SICAQ: number;
}
export interface IInforProposta {
    DS_STATUS_PROPOSTA: string;
    DS_RESPONSAVEL_PROPOSTA: string;
}

export function InforAtendimentoVendas(props: IAtendimentoVendas) {
    moment.locale("pt-br");

    return (
        <div className="d-flex flex-column">
            <div className="d-flex flex-wrap align-itens-center justify-content-between">
                <div className="d-flex flex-column">
                    <div className="d-flex flex-column align-itens-center mb-2">
                        <div className="d-flex flex-column align-itens-center mt-2 mb-5">
                            <div className="d-flex align-items-center">
                                <div className="symbol symbol-success mr-2">
                                    <FontAwesomeIcon
                                        icon={faHome}
                                        className="svg-icon icon-xl text-info d-lg-flex"
                                    />
                                </div>
                                <div className="d-flex flex-column text-left">
                                    <span className="text-muted font-weight-bold">
                                        Produto de Interesse
                                    </span>
                                    <span className="text-dark-75 font-weight-bold">
                                        {
                                            props.InforProdutosVendas
                                                .DS_PRODUTO_OPORTUNIDADE
                                        }
                                    </span>
                                </div>
                                <hr />
                            </div>
                            <div className="d-flex align-items-center mt-5">
                                <div className="symbol symbol-success mr-2">
                                    <FontAwesomeIcon
                                        icon={faHome}
                                        className="svg-icon icon-xl text-warning d-lg-flex"
                                    />
                                </div>
                                <div className="d-flex flex-column text-left">
                                    <span className="text-muted font-weight-bold">
                                        Produto Reservado
                                    </span>
                                    <span className="text-dark-75 font-weight-bold">
                                        RESIDENCIAL UP NOVA IGUAÇU - FASE I
                                    </span>
                                    <span className="text-dark-75 font-weight-bold">
                                        BL02 APTO 0406 -{" "}
                                        <strong>Valida por 2 Dias</strong>
                                    </span>
                                </div>
                                <hr />
                            </div>

                            <div className="d-flex align-items-center mt-5">
                                <div className="symbol symbol-success mr-2">
                                    <FontAwesomeIcon
                                        icon={faHome}
                                        className={`svg-icon icon-xl d-lg-flex ${
                                            props.InforProdutosVendas
                                                .DS_EMPREENDIMENTO_VENDA
                                                ? "text-success"
                                                : "text-danger"
                                        }`}
                                    />
                                </div>
                                <div className="d-flex flex-column text-left">
                                    <span className="text-muted font-weight-bold">
                                        Produto Vendido
                                    </span>
                                    <span className="text-dark-75 font-weight-bold">
                                        <span className="d-flex flex-column">
                                            <span
                                                className={`font-weight-bold ${
                                                    props.InforProdutosVendas
                                                        .DS_EMPREENDIMENTO_VENDA
                                                        ? "text-dark-75"
                                                        : "text-danger"
                                                }`}
                                            >
                                                {props.InforProdutosVendas
                                                    .DS_EMPREENDIMENTO_VENDA ||
                                                    "Ele ainda não comprou :("}
                                            </span>
                                            <span className="text-dark-100 font-weight-bold">
                                                {
                                                    props.InforProdutosVendas
                                                        .DS_UNIDADE_VENDA
                                                }
                                            </span>
                                        </span>
                                    </span>
                                </div>
                                <hr />
                            </div>
                        </div>

                        <span>{props.InforCliente.DS_EMAIL}</span>
                        <span>{props.InforCliente.DS_ORIGEM_LEAD}</span>

                        <div className="d-flex justify-content-start">
                            {props.InforCliente.NR_TELEFONE &&
                                props.InforCliente.NR_TELEFONE[0] && (
                                    <OverlayTrigger
                                        overlay={
                                            <Tooltip
                                                id="email-tooltip"
                                                className={`cliente-tooltip ${
                                                    props.InforCliente
                                                        .NR_TELEFONE.length <=
                                                        1 && "tooltip-disabled"
                                                } `}
                                            >
                                                <div className="d-flex flex-column">
                                                    {props.InforCliente.NR_TELEFONE.map(
                                                        (phone) => {
                                                            return (
                                                                <span
                                                                    key={phone}
                                                                    className="label label-xl label-secundary label-inline mr-2"
                                                                >
                                                                    {formatedTelefone(
                                                                        phone
                                                                    )}
                                                                </span>
                                                            );
                                                        }
                                                    )}
                                                </div>
                                            </Tooltip>
                                        }
                                        trigger={["click"]}
                                    >
                                        <span
                                            className="label label-light-dark label-inline mt-1 d-flex justify-content-center"
                                            style={{
                                                height: "auto",
                                                minHeight: "20px",
                                            }}
                                        >
                                            <FontAwesomeIcon
                                                icon={faPhone}
                                                className="mr-1"
                                            />
                                            {formatedTelefone(
                                                props.InforCliente
                                                    .NR_TELEFONE[0]
                                            )}
                                            {props.InforCliente.NR_TELEFONE
                                                .length > 1 && (
                                                <FontAwesomeIcon
                                                    icon={faPlus}
                                                    className="ml-2"
                                                />
                                            )}
                                        </span>
                                    </OverlayTrigger>
                                )}
                        </div>
                    </div>
                </div>
                <div className="d-flex flex-column text-center mt-5 mb-0">
                    <div className="d-flex flex-column align-itens-center ">
                        <h5>Relogio de dias </h5>

                        <label>
                            {
                                props.InforEquipeAtendimento
                                    .DS_USUARIO_RESPONSAVEL_GA
                            }
                        </label>
                        <label>
                            {props.InforEquipeAtendimento.DS_EQUIPE_VENDA_GA}
                        </label>
                    </div>

                    <div className="d-flex flex-column align-itens-center ">
                        <span className="label label-xl label-success label-inline mr-2">
                            {props.DS_ETAPA}
                        </span>
                    </div>
                    <strong className="ml-2 mt-2 text-danger">
                        Cliente esta a 337 dias 16 horas 12 minutos nesta etapa.
                    </strong>
                    <strong className="ml-2 text-danger">
                        Você perdera este lead em 4 horas, caso não ocorra
                        nenhuma interaçãos.
                    </strong>
                </div>
                <div className="d-flex flex-column  text-end">
                    <label className="font-size-lg text-success mt-1 text-right">
                        Valor da Oportunidade: <strong>R$ 250.000,00</strong> -
                        Potencial de Comissão <strong>R$ 10.000,00</strong>
                    </label>
                    <div className="d-flex flex-wrap align-itens-center justify-content-center">
                        <span className="bg-light-success mr-2 d-flex flex-column p-3 border border-success rounded mt-3">
                            <h5>Analise de Credito</h5>
                            <label>
                                Status:{" "}
                                {
                                    props.InforAnaliseCredito
                                        ?.DS_STATUS_ANALISE_CREDITO
                                }
                            </label>
                            <label>
                                Validade:{" "}
                                {
                                    props.InforAnaliseCredito
                                        ?.DT_VALIDADE_ANALISE_CREDITO
                                }
                            </label>
                            <label>
                                Valor SICAQ.:{" "}
                                {
                                    props.InforAnaliseCredito
                                        ?.VL_SICAQ_APROVADO_ANALISE_CREDITO
                                }
                            </label>
                            <label>
                                Responsável:{" "}
                                {
                                    props.InforAnaliseCredito
                                        ?.DS_USUARIO_RESPONSAVEL_ANALISE_CREDITO
                                }
                            </label>
                        </span>

                        {props.lstInforProposta?.forEach((Proposta) => {
                            if (Proposta.ID_PROPOSTA)
                                return (
                                    <>
                                        <span
                                            className={`${setClassBgStatus(
                                                Proposta.DS_STATUS_PROPOSTA ||
                                                    "",
                                                "APROVADO",
                                                "NÃO APROVADO"
                                            )} mr-2 d-flex flex-column p-3 border rounded mt-3`}
                                        >
                                            <h5>
                                                {Proposta.ID_PROPOSTA} -
                                                Proposta
                                            </h5>
                                            <label>
                                                Status:
                                                <strong
                                                    className={`${setClassLabelStatus(
                                                        Proposta.DS_STATUS_PROPOSTA ||
                                                            "",
                                                        "APROVADO",
                                                        "NÃO APROVADO"
                                                    )} ml-2`}
                                                >
                                                    {
                                                        Proposta.DS_STATUS_PROPOSTA
                                                    }
                                                </strong>
                                            </label>
                                            <label>
                                                Dt. Proposta.:{" "}
                                                {moment(
                                                    Proposta.DT_CRIACAO_PROPOSTA
                                                ).format("L")}
                                            </label>
                                            <label>
                                                Valor.:{" "}
                                                {formatMoneyReais(
                                                    Proposta.VL_TOTAL_PROPOSTA ||
                                                        0
                                                )}
                                            </label>
                                            <label>
                                                Responsável:{" "}
                                                {
                                                    Proposta.DS_USUARIO_RESPONSAVEL_PROPOSTA
                                                }
                                            </label>
                                        </span>
                                    </>
                                );
                        })}

                        <span className="bg-secondary mr-2 d-flex flex-column p-3 border border-secondary rounded mt-3">
                            <h5>Contrato</h5>
                            <label>Status Análise Créd.: APROVADA</label>
                            <label>Validade Análise Créd.: 04/10/2022</label>
                            <label>Valor SICAQ.: R$ 116.000,00</label>
                            <label>Responsável: ASSINO ASSESSORIA</label>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}
